import { render, staticRenderFns } from "./ModalImage.vue?vue&type=template&id=95a0d456&scoped=true&"
import script from "./ModalImage.vue?vue&type=script&lang=ts&"
export * from "./ModalImage.vue?vue&type=script&lang=ts&"
import style0 from "./ModalImage.vue?vue&type=style&index=0&id=95a0d456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a0d456",
  null
  
)

export default component.exports